import React from 'react';
import styled from 'styled-components';

import { overrideProperties } from '@ecp/common/src/style/utils';
import { sizePropTypes } from '@ecp/common/src/style/propTypes';
import defaultChecked from '@ecp/common/src/assets/icon/checkbox__bo--checked.svg';
import defaultDisabled from '@ecp/common/src/assets/icon/checkbox__bo--disabled.svg';
import defaultDisabledChecked from '@ecp/common/src/assets/icon/checkbox__bo--disabled_checked.svg';
import defaultUnchecked from '@ecp/common/src/assets/icon/checkbox__bo--unchecked.svg';
import defaultHovered from '@ecp/common/src/assets/icon/checkbox__bo--hovered.svg';

const CheckBoxComponent = (props) => {
  return <DefaultCheckbox {...props} />;
};

const DefaultCheckbox = styled.div`
  ${overrideProperties(sizePropTypes, { width: '20px', height: '20px' })}
  background: url(${defaultChecked}) no-repeat;
  background-size: ${({ width }) => width || '20px'};
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }

  &.checkbox-checked {
    background-image: url(${defaultChecked});

    &:hover {
      background-image: url(${defaultHovered});
    }
  }

  &.checkbox-unchecked {
    background-image: url(${defaultUnchecked});
  }

  &.checkbox-disabled {
    background-image: url(${defaultDisabled});

    &:hover {
      cursor: not-allowed;
      background-image: url(${defaultDisabled});
    }

    &.checkbox-checked {
      background-image: url(${defaultDisabledChecked});
    }
  }
`;

export default CheckBoxComponent;
